import { ErrorStatusTypes } from '../constants/ErrorStatusTypes';
import routeNames from '../constants/routeNames';
import moment from 'moment';

const routeHelper = (type, content, navigate, data, registerData) => {
    const c = content?.pages?.errors_list?.content;
    let redeemDate;
    let redeemDateFormatted;
    let now = new Date();
    if (
        type === ErrorStatusTypes.ALREADY_REDEEMED_NO_LIMIT &&
        registerData &&
        registerData.error.data.redeemDate
    ) {
        redeemDate = new Date(registerData.error.data.redeemDate);
        now.setDate(now.getDate() + 1);
        if (
            redeemDate.getFullYear() === now.getFullYear() &&
            redeemDate.getMonth() === now.getMonth() &&
            redeemDate.getDate() === now.getDate()
        ) {
            redeemDate = 'tomorrow';
        } else {
            redeemDate = `on ${moment(registerData.error.data.redeemDate).format('dddd, Do MMMM')}`;
        }
        redeemDateFormatted = `${redeemDate}`;
    }

    const messages = {
        [ErrorStatusTypes.RETAILER_LIMIT]: {
            title: c?.retailer_limit_error_title?.value,
            desc: c?.retailer_limit_error_description?.value,
            button_text: c?.limit_button_text?.value,
        },
        [ErrorStatusTypes.DAILY_LIMIT]: {
            title: c?.daily_limit_error_title?.value,
            desc: c?.daily_limit_error_description?.value,
            button_text: c?.limit_button_text?.value,
        },
        [ErrorStatusTypes.CAMPAIGN_LIMIT]: {
            title: c?.campaign_limit_error_title?.value,
            desc: c?.campaign_limit_error_description?.value,
            button_text: c?.limit_button_text?.value,
        },
        [ErrorStatusTypes.RETAILER_OFF]: {
            title: c?.retailer_off_error_title?.value,
            desc: c?.retailer_off_error_description?.value,
        },
        [ErrorStatusTypes.VENUE_OFF]: {
            title: c?.retailer_off_error_title?.value,
            desc: c?.retailer_off_error_description?.value,
        },
        [ErrorStatusTypes.ALREADY_SIGNUP]: {
            title: c?.already_signed_up_not_redeemed_title?.value,
            desc: c?.already_signed_up_not_redeemed_description?.value,
            button: c?.already_signed_up_not_redeemed_button_text?.value,
        },
        [ErrorStatusTypes.ALREADY_REDEEMED_NO_LIMIT]: {
            title: c?.already_redeemed_no_limit_title?.value,
            desc: `${
                redeemDateFormatted
                    ? `${c?.already_redeemed_no_limit_description?.value?.replace(
                          '{{date}}',
                          redeemDateFormatted
                      )}`
                    : ''
            }`,
        },
        [ErrorStatusTypes.NO_LOCATION]: {
            title: c?.location_error_title?.value,
            desc: c?.check_faq?.value,
        },
    };

    switch (type) {
        case ErrorStatusTypes.DAILY_LIMIT:
            navigate(routeNames.NOT_AVAILABLE_DAILY_LIMIT, {
                state: {
                    title: messages[ErrorStatusTypes.DAILY_LIMIT].title,
                    desc: messages[ErrorStatusTypes.DAILY_LIMIT].desc,
                    button_text: messages[ErrorStatusTypes.DAILY_LIMIT].button_text,
                    uniqueId: registerData?.error?.data?.uniqueId,
                    showIWButton: true,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.RETAILER_LIMIT:
            navigate(routeNames.NOT_AVAILABLE_RETAILER_LIMIT, {
                state: {
                    title: messages[ErrorStatusTypes.RETAILER_LIMIT].title,
                    desc: messages[ErrorStatusTypes.RETAILER_LIMIT].desc,
                    button_text: messages[ErrorStatusTypes.RETAILER_LIMIT].button_text,
                    uniqueId: registerData?.error?.data?.uniqueId,
                    showSelectDifferent: true,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.CAMPAIGN_LIMIT:
            navigate(routeNames.NOT_AVAILABLE_CAMPAIGN_LIMIT, {
                state: {
                    title: messages[ErrorStatusTypes.CAMPAIGN_LIMIT].title,
                    desc: messages[ErrorStatusTypes.CAMPAIGN_LIMIT].desc,
                    button_text: messages[ErrorStatusTypes.CAMPAIGN_LIMIT].button_text,
                    uniqueId: registerData?.error?.data?.uniqueId,
                    showIWButton: true,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.RETAILER_OFF:
            navigate(routeNames.NOT_AVAILABLE_RETAILER_OFF, {
                state: {
                    title: messages[ErrorStatusTypes.RETAILER_OFF].title,
                    desc: messages[ErrorStatusTypes.RETAILER_OFF].desc,
                    showSelectDifferent: true,
                    uniqueId: registerData?.error?.data?.uniqueId,
                    type: registerData?.error?.data?.type,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.VENUE_OFF:
            navigate(routeNames.NOT_AVAILABLE_VENUE_OFF, {
                state: {
                    title: messages[ErrorStatusTypes.VENUE_OFF].title,
                    desc: messages[ErrorStatusTypes.VENUE_OFF].desc,
                    showSelectDifferent: true,
                    uniqueId: registerData?.error?.data?.uniqueId,
                    type: registerData?.error?.data?.type,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.CAMPAIGN_OFF:
            navigate(routeNames.PROMOTION_CLOSED, {
                replace: true,
            });
            break;
        case ErrorStatusTypes.NO_LOCATION:
            navigate(routeNames.NO_LOCATION, {
                state: {
                    title: messages[ErrorStatusTypes.NO_LOCATION].title,
                    desc: messages[ErrorStatusTypes.NO_LOCATION].desc,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.ALREADY_SIGNUP:
            navigate(routeNames.ALREADY_SIGNED_UP, {
                state: {
                    title: messages[ErrorStatusTypes.ALREADY_SIGNUP].title,
                    desc: messages[ErrorStatusTypes.ALREADY_SIGNUP].desc,
                    button: messages[ErrorStatusTypes.ALREADY_SIGNUP].button,
                    data: data,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.ALREADY_REDEEMED_NO_LIMIT:
            navigate(routeNames.ALREADY_REDEEMED, {
                state: {
                    title: messages[ErrorStatusTypes.ALREADY_REDEEMED_NO_LIMIT].title,
                    desc: messages[ErrorStatusTypes.ALREADY_REDEEMED_NO_LIMIT].desc,
                    type: true,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.INSTANT_WIN_USER_NOT_WINNER:
            navigate(routeNames.INSTANT_WIN_NO_WIN, {
                state: {
                    redirected: true,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.INSTANT_WIN_USER_ALREADY_CLAIMED:
            navigate(routeNames.INSTANT_WIN_ALREADY_REDEEMED, {
                state: {
                    redirected: true,
                },
                replace: true,
            });
            break;

        case ErrorStatusTypes.INSTANT_WIN_USER_LINK_EXPIRED:
            navigate(routeNames.INSTANT_WIN_LINK_EXPIRED, {
                state: {
                    redirected: true,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.INSTANT_WIN_USER_TOO_EARLY:
            navigate(routeNames.INSTANT_WIN_TOO_EARLY, {
                state: {
                    swipedDate: registerData?.error?.data?.swipedDate,
                    unique: registerData?.error?.data?.unique,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.GAME_IN_PROGRESS:
            navigate(routeNames.PREDICTION_GAME_IN_PROGRESS, {
                state: {
                    unique: registerData?.error?.data?.unique,
                    venue: registerData?.error?.data?.venue,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.GAME_NOT_STARTED:
            navigate(routeNames.PREDICTION_GAME_NOT_STARTED, {
                state: {
                    unique: registerData?.error?.data?.unique,
                    venue: registerData?.error?.data?.venue,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.PREDICTION_WRONG:
            navigate(routeNames.PREDICTION_LOST, {
                state: {
                    redirected: true,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.LOYALTY_COME_BACK_LATER:
            navigate(routeNames.LOYALTY_COME_BACK_LATER, {
                state: {
                    userId: registerData?.error?.data?.userId,
                    date: registerData?.error?.data?.date,
                    currentStep: registerData?.error?.data?.currentStep,
                },
                replace: true,
            });
            break;
        case ErrorStatusTypes.LOYALTY_COMPLETED:
            navigate(`/location-check/${registerData?.error?.data?.userId}/email`, {
                replace: true,
            });
            break;
        case ErrorStatusTypes.LOYALTY_NOT_COMPLETED:
            navigate(`/loyalty/location-check/${registerData?.error?.data?.userId}`, {
                replace: true,
            });
            break;
        default:
            navigate(routeNames.HOME);
            break;
    }
};

export default routeHelper;
